/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1BookbindingbindingsQueryResponse } from '../../types/GetV1Bookbindingbindings.ts'

export const getV1BookbindingbindingsQueryKey = () => [{ url: '/v1/BookBindingBindings' }] as const

export type GetV1BookbindingbindingsQueryKey = ReturnType<typeof getV1BookbindingbindingsQueryKey>

/**
 * {@link /v1/BookBindingBindings}
 */
export async function getV1Bookbindingbindings(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1BookbindingbindingsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/BookBindingBindings`, ...requestConfig })
    return res
}

export function getV1BookbindingbindingsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1BookbindingbindingsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1BookbindingbindingsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1BookbindingbindingsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Bookbindingbindings(config)
        },
    })
}

/**
 * {@link /v1/BookBindingBindings}
 */
export function useGetV1Bookbindingbindings<
    TData = ResponseConfig<GetV1BookbindingbindingsQueryResponse>,
    TQueryData = ResponseConfig<GetV1BookbindingbindingsQueryResponse>,
    TQueryKey extends QueryKey = GetV1BookbindingbindingsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1BookbindingbindingsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1BookbindingbindingsQueryKey()

    const query = useQuery(
        {
            ...getV1BookbindingbindingsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
